module.exports = __webpack_public_path__ + "media/dice-video.fa6534de.mp4";